import gql from 'graphql-tag';

export const GET_ALL_SPECIES = gql`
  query SpecyFindAll(
    $skip: Int
    $take: Int
    $orderBy: [SpecyOrderByWithRelationAndSearchRelevanceInput!]
    $where: SpecyWhereInput
  ) {
    SpecyFindAll(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
      id
      internalId
      name
      tag
      isActive
      isCorrupted
      parentId
    }
  }
`;

export const GET_SPECIE_BY_ID = gql`
  query SpecyFindOne($where: SpecyWhereUniqueInput!) {
    SpecyFindOne(where: $where) {
      id
      internalId
      name
      tag
      parentId
      isActive
      isCorrupted
      appliesImportTax
    }
  }
`;

export const ADD_SPECIE = gql`
  mutation SpecyCreate($data: SpecyCreateInput!) {
    SpecyCreate(data: $data) {
      id
    }
  }
`;

export const UP_SPECIE = gql`
  mutation SpecyUpdate(
    $data: SpecyUpdateInput!
    $where: SpecyWhereUniqueInput!
  ) {
    SpecyUpdate(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_SPECIE_MUTATION = gql`
  mutation SpecyDelete($where: SpecyWhereUniqueInput!) {
    SpecyDelete(where: $where) {
      id
    }
  }
`;

export const GET_SPECY_CAPACITY_GRID = gql`
  query SpecyCapacityGrid($specyId: Int!) {
    SpecyCapacityGrid(specyId: $specyId) {
      specyId
      containerTypes {
        id
        name
        quantityInM3
        maxPayloadTons
      }
      rows {
        dryTypeId
        dryTypeName
        derived
        cells {
          quantityTypeId
          capacityM3
          densityTonPerM3
          source
          exceedsPhysicalVolume
          derived
          missing
        }
      }
    }
  }
`;

export const GET_SPECY_CAPACITY_COMPLETENESS = gql`
  query SpecyCapacityCompleteness($specyIds: [Int!]!) {
    SpecyCapacityCompleteness(specyIds: $specyIds) {
      specyId
      totalCells
      filledCells
      missingCells
    }
  }
`;

export const UPSERT_SPECY_CONTAINER_CAPACITY = gql`
  mutation SpecyContainerCapacityUpsert($data: SpecyContainerCapacityUpsertInput!) {
    SpecyContainerCapacityUpsert(data: $data) {
      id
      specyId
      dryTypeId
      quantityTypeId
      capacityM3
    }
  }
`;

export const DELETE_SPECY_CONTAINER_CAPACITY = gql`
  mutation SpecyContainerCapacityDelete(
    $specyId: Int!
    $dryTypeId: Int!
    $quantityTypeId: Int!
  ) {
    SpecyContainerCapacityDelete(
      specyId: $specyId
      dryTypeId: $dryTypeId
      quantityTypeId: $quantityTypeId
    )
  }
`;
